import React from 'react';
import { Persistence } from './Persistence';

export const PersistenceContext = React.createContext<Persistence | null>(null);

export const PersistenceProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const persistence = new Persistence();

    return <PersistenceContext.Provider value={persistence}>{children}</PersistenceContext.Provider>;
};

export const usePersistence = (): Persistence => {
    const persistence = React.useContext(PersistenceContext);

    if (!persistence) {
        throw new Error('SERP History context is not provided');
    }

    return persistence;
};
